import actions from './actions';
import LfDataService from '../../../Services/LfDataService';

import {
    pageIsLoadingAction, 
    pageLoadedAction, 
    pageHasErroredAction, 
    pageErrorAction
} from '../../../State/actions';
import coInsuredInfo from '../Reducers/coInsuredInfo';


export function fetchCustomerInfo() {
    const lfDataService = new LfDataService();

    return (dispatch) => {
        let customerInfo;
        let coinsuredInfo; 

        dispatch(setCustomerInfoFetching(true));
        dispatch(setCoInsuredInfoFetching(true));

        lfDataService.customerInfo()
            .then(data => {
                customerInfo = data.customer;
                coinsuredInfo = data.currentCoinsured;

                dispatch(setCustomerInfo(customerInfo));
                dispatch(setCoInsuredInfo(coinsuredInfo));

                dispatch(setCustomerInfoFetching(false));
                dispatch(setCoInsuredInfoFetching(false));
            })
            .catch(e => {
                dispatch(pageErrorAction(e));
                dispatch(pageHasErroredAction(true));
            });
    };
}

export function postNewContactInfo(data) {
    const lfDataService = new LfDataService();

    return (dispatch) => {
        dispatch(pageIsLoadingAction(true));
        dispatch(setCustomerInfoFetching(true));

        lfDataService.updateProfile(data)
            .then(result => {
                dispatch(pageIsLoadingAction(false));
                dispatch(pageErrorAction('kunde inte uppdatera dina kontaktuppgifter'));
                dispatch(pageHasErroredAction(true));
                dispatch(fetchCustomerInfo());
            })
            .catch(e => {
                dispatch(pageIsLoadingAction(true));
                dispatch(pageErrorAction(e));
                dispatch(pageHasErroredAction(true));
            });
    }
}

export function setCustomerInfo(data) {
    return {
        type: actions.CUSTOMER_INFO_SET,
        payload: data
    };
}
export function setCoInsuredInfo(data) {
    return {
        type: actions.COINSURED_INFO_SET,
        payload: data
    };
}
export function setCustomerInfoFetching(data) {
    return {
        type: actions.CUSTOMER_INFO_FETCHING_SET,
        payload: !!data
    };
}
export function setCoInsuredInfoFetching(data) {
    return {
        type: actions.COINSURED_INFO_FETCHING_SET,
        payload: !!data
    };
}